import { useNavigate } from "react-router-dom"
import { BuildingOfficeIcon, UserPlusIcon } from '@heroicons/react/24/outline'
import { ChevronRightIcon } from '@heroicons/react/20/solid'
import kinesisLogo from "media/kinesis_logo.png"

import ScreenFrame from "components/Frame/ScreenFrame"
import ContentFrame from "components/Frame/ContentFrame"

export default function CoachAccountSetupOptionsView() {

    const navigate = useNavigate()

    return (
        <ScreenFrame contentClassName="h-full">
            <div className="flex flex-col h-full w-2/3 mx-auto gap-y-4">
                
                {/* Header */}
                <div className="text-center space-y-2">
                    <div className="flex justify-center mb-2">
                        <img
                            src={kinesisLogo}
                            alt="Kinesis Logo"
                            className="w-32 h-auto"
                        />
                    </div>

                    <h2 className="text-2xl text-gray-900">
                        Welcome to the Kinesis Coach Dashboard!
                    </h2>

                    <p className="text-base text-gray-600 max-w-xl mx-auto">
                        You're just a few short steps away from transforming how
                        <br />strength training is managed for your athletes!
                    </p>

                    <p className="py-2 font-semibold">How would you like to get started?</p>
                </div>

                {/* Create Organization Option */}
                <ContentFrame>
                    <div
                        className='w-full flex items-center p-6 gap-x-6 text-gray-600 cursor-pointer hover:bg-gray-50'
                        onClick={() => navigate('/organization/create')}
                    >
                        <div className="h-20 w-20 bg-orange-400 rounded-full items-center">
                            <BuildingOfficeIcon className="h-12 text-white m-4" />
                        </div>

                        <div className='space-y-1 flex-1'>
                            <div className='text-2xl font-semibold'>Create an Organization</div>
                            <div className="text-base">I am an owner/leader and need to create my organization on Kinesis</div>
                        </div>

                        <ChevronRightIcon className="text-gray-400 h-10" />
                    </div>
                </ContentFrame>

                {/* Join Organization Option */}
                <ContentFrame>
                    <div
                        className='w-full flex items-center p-6 gap-x-6 text-gray-600 cursor-pointer hover:bg-gray-50'
                        onClick={() => navigate('/organization/join')}
                    >
                        <div className="h-20 w-20 bg-orange-400 rounded-full items-center">
                            <UserPlusIcon className="h-12 text-white m-4" />
                        </div>

                        <div className='space-y-1 flex-1'>
                            <div className='text-2xl font-semibold'>Join an Existing Organization</div>
                            <div className="text-base">I am a coach/employee and need to join an existing Kinesis organization</div>
                        </div>

                        <ChevronRightIcon className="text-gray-400 h-10" />
                    </div>
                </ContentFrame>

                {/* Support Note */}
                <p className='mt-auto text-center text-gray-600'>
                    Need help? Contact us at <a href="mailto:support@kinesisintegrated.com" className="text-blue-500 underline">support@kinesisintegrated.com</a>
                </p>
            </div>
        </ScreenFrame>
    )
}